import * as classnames from 'classnames'
import * as React from 'react'

import FavoriteIcon from '../../../components/icons/favorite'

import * as styles from './favoriteButton.module.css'

interface IProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement | HTMLButtonElement> {
  isActive?: boolean
  iconClassName?: string
}

const FavoriteButton = ({
  href,
  onClick,
  isActive = false,
  className = '',
  iconClassName = ''
}: IProps) => {
  const classes = classnames(styles.link, {
    [styles.linkActive]: isActive,
    [className]: !!className
  })

  const iconClassNames = classnames(styles.icon, [iconClassName])

  return (
    <a
      role="button"
      href={href}
      className={classes}
      onClick={onClick}
      rel="nofollow"
    >
      <FavoriteIcon className={iconClassNames} />
    </a>
  )
}

export default FavoriteButton
